import { useMemo, useState } from "react";
import { JournalCard } from "../pages/Blog";
import { useJournalArchive } from "../lib/useJournal";

const PAGE = 12;

// Full archive of imported articles with a category filter and "show more".
export const JournalArchive = () => {
  const items = useJournalArchive();
  const [cat, setCat] = useState("All");
  const [shown, setShown] = useState(PAGE);
  const cats = useMemo(() => ["All", ...Array.from(new Set(items.map((a) => a.category)))], [items]);
  const list = cat === "All" ? items : items.filter((a) => a.category === cat);
  if (!items.length) return null;
  return (
    <section className="border-t border-neutral-200 bg-white py-20 md:py-28" data-testid="journal-archive">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <p className="text-center text-[10px] uppercase tracking-[0.45em] text-neutral-500">From the Archive · {items.length} Stories</p>
        <div className="no-scrollbar mt-8 flex gap-6 overflow-x-auto border-b border-neutral-200 pb-4 md:justify-center" data-testid="journal-archive-filters">
          {cats.map((c) => (
            <button key={c} onClick={() => { setCat(c); setShown(PAGE); }} data-testid={`journal-filter-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`shrink-0 text-[11px] uppercase tracking-[0.25em] transition-colors ${cat === c ? "text-neutral-950 underline underline-offset-8" : "text-neutral-500 hover:text-neutral-950"}`}>{c}</button>
          ))}
        </div>
        <div className="mt-14 grid gap-14 md:grid-cols-2 lg:grid-cols-3">
          {list.slice(0, shown).map((a) => <JournalCard key={a.slug} a={a} />)}
        </div>
        {shown < list.length && (
          <div className="mt-16 text-center">
            <button onClick={() => setShown((n) => n + PAGE)} className="btn-line" data-testid="journal-show-more">Show More Stories</button>
          </div>
        )}
      </div>
    </section>
  );
};
